// extracted by mini-css-extract-plugin
module.exports = {"benefitCard":"benefits-module--benefitCard--1z7ne","green":"benefits-module--green--2vzWU"};